/* jshint undef: true, unused: true */

const nJ = require('../../../js_functions/form-builder/js/not-jquery');
const irmf = {};
let  messageTimeout;

irmf.showMessage = function(message, type) {
  var wrapDiv           = document.getElementsByClassName('col form-wrapper')[0],
      infoMessage       = document.createElement('div'),
      headerErrorBuffer,
      errors,
      error;

  type = type || 'message';

  // This sets the error banner to the width of the form but it won't respond to resizing.
  var formWrapper = document.querySelector('#datix-content .form-wrapper #main-content');
  if(formWrapper && typeof formWrapper.offsetWidth === 'number' && formWrapper.offsetWidth > 0 ) {
    infoMessage.style.width = formWrapper.offsetWidth + "px";
  }

  // Check for existing meds / equip message
  if(messageTimeout) {
    headerErrorBuffer = wrapDiv.querySelector('#header-error-buffer');
  } 
  
  // If it doesn't exist create it.
  if(!headerErrorBuffer) {
    headerErrorBuffer = document.createElement('div');
    headerErrorBuffer.setAttribute('id','header-error-buffer');
    // Detect whether the page is scrolled. Otherwise we can 
    // add the messages above the form as usual.
    if(window && window.pageYOffset) {
      nJ.addClass(headerErrorBuffer,'header-error-buffer-fixed');
    }
  }

  if(type === 'error') {

    nJ.addClass(infoMessage,'error_div');

    if (typeof message !== 'string' && message.responseText) {
      // GraphQL Errors
      try {
        errors = JSON.parse(message.responseText).errors;
      } catch(e) {
        console.error(e, message.responseText);
        return;
      }

      for (error in errors) {
        if (errors.hasOwnProperty(error)) {
          infoMessage.innerHTML += 'ERROR: ' + errors[error].message + '<br>';
        }
      }
      
    } else {
      var surfacedError = typeof message === 'string' ? message : 'An unknown error has occurred';
      infoMessage.innerHTML = 'ERROR: ' + surfacedError;
    }
  } else {
    nJ.addClass(infoMessage,'info_div');
    infoMessage.innerHTML = message;
  }

  // this will make sure the error is inserted before any previous message.
  headerErrorBuffer.insertBefore(infoMessage, headerErrorBuffer.firstChild);

  if(wrapDiv) {
    clearTimeout(messageTimeout);
    wrapDiv.insertBefore(headerErrorBuffer, wrapDiv.firstChild);
    messageTimeout = setTimeout(function() {
      messageTimeout = null;
      wrapDiv.removeChild(headerErrorBuffer);
    }, 10000);
  }

};

irmf.buildContentTable = function (domId, options) {

  var structure = options.tableOptions && options.tableOptions.contentClass
    && options.tableOptions.contentClass.options && options.tableOptions.contentClass.options.structure;

  options.translations.translateForm(structure);
  options.translations.translateForm(options.tableOptions.contentDisplaySettings.structure);

  options.tableOptions.data             = options.existingFormData || [];

  return new options.cmdClass( domId, options.tableOptions );
};

irmf.initInputWithButton = function (targetInput, targetInputAddonElement, onClick) {
  var checkIfButtonDisabled = function (event) {
    nJ.removeClass(targetInputAddonElement, '__icon--disabled');
    if (event.target.value.length < 2) {
      $(targetInputAddonElement).addClass('__icon--disabled');
    }
  };
  var addonClickHandler = function () {
    if (!$(targetInputAddonElement).hasClass('__icon--disabled')) {
      onClick(targetInput);
    }
  };
  var keyPressHandler = function (event) {
    if (event.keyCode === 13) {
      addonClickHandler();
    }
  };

  targetInput.removeEventListener('keyup', checkIfButtonDisabled);
  targetInput.removeEventListener('keypress', keyPressHandler);
  targetInput.removeEventListener('onClearedEvent', checkIfButtonDisabled);
  targetInputAddonElement.removeEventListener('click', addonClickHandler);
  targetInput.addEventListener('keyup', checkIfButtonDisabled);
  targetInput.addEventListener('keypress', keyPressHandler);
  targetInput.addEventListener('onClearedEvent', checkIfButtonDisabled);
  targetInputAddonElement.addEventListener('click', addonClickHandler);
};

// Checks whether the form is locked or readonly.
irmf.isEditable = function () {
  return ['Locked', 'ReadOnly'].indexOf($('#form_mode').val()) === -1;
};

module.exports = irmf;
